var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImgPlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_no_image",
    "data-name": "Icon_no image",
    transform: "translate(7060 -21143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23855",
    "data-name": "Rectangle 23855",
    width: 18,
    height: 18,
    transform: "translate(-7060 21143)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "image-",
    transform: "translate(-7058.594 21144.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61413",
    "data-name": "Path 61413",
    d: "M13.116,12.691,11.35,8.562c-.322-.756-.8-1.185-1.348-1.213A1.7,1.7,0,0,0,8.535,8.421L7.464,10.345a1.182,1.182,0,0,1-.9.677,1.158,1.158,0,0,1-1-.519l-.124-.158a1.6,1.6,0,0,0-1.4-.694,1.6,1.6,0,0,0-1.23.97l-.976,1.946a2.246,2.246,0,0,0,2.008,3.255h7.2a2.25,2.25,0,0,0,1.879-1.01,2.208,2.208,0,0,0,.2-2.121Z",
    transform: "translate(0 -2.496)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61414",
    "data-name": "Path 61414",
    d: "M5.5,5.435A1.907,1.907,0,1,0,3.59,3.528,1.907,1.907,0,0,0,5.5,5.435Z",
    transform: "translate(-0.87)",
    fill: "#818181"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImgPlaceholder);
export default __webpack_public_path__ + "static/media/no_img__placeholder.444b0438670e2be0015115378ca588fb.svg";
export { ForwardRef as ReactComponent };